import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import { ContentBrokenGridViewModel } from './ContentBrokenGridModule.types';
import ContentBrokenCard from '@/components/ContentBrokenCard/ContentBrokenCard.vue';
import { getResizeImage } from '@/utils/commonUtils';

const ContentBrokenGridModuleProps = Vue.extend({
  props: getComponentProps<ContentBrokenGridViewModel>({
    Title: 'Expertise',
    Text:
      'Our expertise comes from diverse backgrounds with knowledge across a number of disciplines',
    Items: [
      {
        Image: { Url: getResizeImage('whale.jpg'), Alt: 'Whale' },
        Text:
          'Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience.',
        Link: {
          Title: 'Read More',
          Link: '#',
        },
        TitleIcon: {
          Path: '',
          Title: 'Expedition Leader',
        }
      },
      {
        Image: { Url: getResizeImage('whale.jpg'), Alt: 'Whale' },
        Text:
          'Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience. This is text that goes longer than 8 lines.',
        Link: {
          Title: 'Read More',
          Link: '#',
        },
        TitleIcon: {
          Path: '',
          Title: 'Expedition Leader',
        }
      },
      {
        Image: { Url: getResizeImage('whale.jpg'), Alt: 'Whale' },
        Video: {
          Url: 'https://www.youtube.com/watch?v=2x24IDoIT40',
          Type: 'video/youtube',
          Poster: getResizeImage('moose.jpg'),
        },
        Text:
          'Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience.',
        Link: {
          Title: 'Read More',
          Link: '#',
        },
        TitleIcon: {
          Path: '',
          Title: 'Naturalist',
        }
      },
      {
        Image: { Url: getResizeImage('vertical-compass.jpg'), Alt: 'Compass' },
        Text:
          'Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience. This is text that goes longer than 8 lines.',
        Link: {
          Title: 'Read More',
          Link: '#',
        },
        TitleIcon: {
          Path: '',
          Title: 'Photo Instructor',
        },
        IsPortrait: true,
      },
      {
        Image: { Url: getResizeImage('whale.jpg'), Alt: 'Whale' },
        Video: {
          Url:
            'https://player.vimeo.com/external/378523265.hd.mp4?s=3675e9d57bf126fd370da439dc1a4d0f5ec7cc43&profile_id=175',
          Type: 'video/mp4',
          Poster: getResizeImage('moose.jpg'),
        },
        Text:
          'Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience.',
        Link: {
          Title: 'Read More',
          Link: '#',
        },
        TitleIcon: {
          Path: '',
          Title: 'Naturalist',
        },
      },
    ],
  }),
});
@Component({
  components: {
    ContentBrokenCard,
  },
})
export default class ContentBrokenGridModule extends ContentBrokenGridModuleProps {
  isOdd(el: number) {
    return el % 2;
  }

  loadMore() {}

  mounted() {
    for (let i = 0; i < this.p.Items.length; i++) {
      if (this.isOdd(i)) {
        const child: any = this.$children[i];
        child.reverseCard();
      }
    }
  }
}
